import {useMutation} from 'react-query';
import {useTranslation} from 'react-i18next';
import api from 'utils/api';
import {setAlert, setSuccessAlert} from 'actions/alerts';

async function updateSubtitleFileLanguage({subtitleId, language}) {
	return api('patch', `/api/subtitles/${subtitleId}`, null, {
		language,
	});
}

function useUpdateSubtitleLanguage() {
	const {t} = useTranslation();

	const {isLoading, isError, mutateAsync} = useMutation(
		updateSubtitleFileLanguage,
		{
			onSuccess: () => {
				setSuccessAlert({
					title: t('alert_update_language_success'),
				});
			},

			onError: err => {
				setAlert({
					title: t('alert_update_language_error'),
					message: err?.error,
				});
			},
		}
	);

	return {isLoading, isError, updateSubtitleLanguage: mutateAsync};
}

export default useUpdateSubtitleLanguage;
